import { isDevelopmentEnvironment } from "@/lib/env";

// Ligado: a funcionalidade só aparece fora de produção (localhost e homologação/DEV), usando a mesma
// verificação de ambiente do resto do sistema (@/lib/env). Desligue (false) para liberar em produção.
export const SCHEDULED_ORDER_STATE_BADGES_DEV_ONLY = true;

export let isScheduledOrderStateBadgesEnabled = false;

// Badges de estado do fluxo de pedidos programados (Materializado/Congelado/Acumulando nas listagens e
// Congelado/Aberto para acumulação/Processado no cabeçalho do detalhe), ocultados em 30/09.
// Comente a linha abaixo para voltar a ocultá-los.
isScheduledOrderStateBadgesEnabled = !SCHEDULED_ORDER_STATE_BADGES_DEV_ONLY || isDevelopmentEnvironment;
